import classnames from 'classnames';
import {v4} from '@utils/uuid';
import {SelectProps as MuiSelectProps} from '@material-ui/core';
import {useDesignContext} from '@theme';
import {BaseSelect} from '../BaseSelect/BaseSelect';
import AppInputLabel from '../../labels/AppInputLabel/AppInputLabel';
import './appSelect.less';

export interface AppSelectProps extends MuiSelectProps {
    htmlFor?: string;
    helperText?: string;
}
export const AppSelect = ({
    children, className, label, htmlFor, id, required, MenuProps, ...rest
}: AppSelectProps) => {
    const {designVersion} = useDesignContext();
    const containerClassName = classnames('app-select-container', className, designVersion);
    const uid = v4();
    const htmlForId = htmlFor !== undefined ? htmlFor : id || uid;
    return (
        <div className={containerClassName}>
            {label && <AppInputLabel id={htmlForId} required={required} htmlFor={uid}>{label}</AppInputLabel>}
            <BaseSelect
                id={id}
                labelId={htmlForId}
                className={classnames(designVersion)}
                MenuProps={{
                    disablePortal: true,
                    ...MenuProps,
                    classes: {
                        ...MenuProps?.classes,
                        list: classnames('app-select-menu', MenuProps?.classes?.list)
                    }
                }}
                {...rest as any}
            >
                {children}
            </BaseSelect>
        </div>
    );
};
export default AppSelect;
